<script lang="ts" setup>
defineProps({
    isSolid: {
        type: Boolean,
        default: false
    }
})
</script>

<template>
    <svg
        v-if="isSolid"
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            fill-rule="evenodd"
            d="M12.7 12.8h-4v-6h4.1c1.3 0 2.7 1.3 2.7 3.1-.1 1.6-1.3 2.8-2.8 2.9ZM13 3H5v18h3.6v-4.6h4.2c3.2 0 6.2-2.9 6.2-6.7C19 6.3 16.4 3 13 3Z"
            clip-rule="evenodd"
        />
    </svg>

    <svg
        v-else
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            fill-rule="evenodd"
            d="M15.999 9.93119 16 9.91561V9.9c0-2.0423-1.5912-3.6-3.2-3.6H8.2v7h4.5166l.0167-.0011c1.7597-.1173 3.1506-1.5261 3.2657-3.36771Zm-1.9995-.07829c-.0722.8313-.6667 1.3816-1.3581 1.4471H10.2v-3h2.6c.168 0 .4658.10966.7358.39305.2534.26594.452.65669.4637 1.15985Z"
            clip-rule="evenodd"
        />
        <path
            fill-rule="evenodd"
            d="M13 1.5H3.5v21h6.6v-4.6h2.7c4.0887 0 7.7-3.6332 7.7-8.2 0-4.00515-3.0647-8.2-7.5-8.2Zm-.2 14.4H8.1v4.6H5.5v-17H13c3.0558 0 5.5 3.00272 5.5 6.2 0 3.5441-2.796 6.2-5.7 6.2Z"
            clip-rule="evenodd"
        />
    </svg>
</template>
